export const SLOTS = {
  dropdownTrigger: "trigger",
};
